/**
 * PrimaryButton Component
 * 재사용 가능한 기본 버튼 (로그인, 회원가입 등)
 */
import React from "react";

interface PrimaryButtonProps {
    type?: 'button' | 'submit' | 'reset';
    onClick?: () => void;
    disabled?: boolean;
    loading?: boolean;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
    showArrow?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
    type = 'button',
    onClick,
    disabled = false,
    loading = false,
    children,
    className = '',
    style,
    showArrow = true,
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            className={`login-button ${loading ? 'loading' : ''} ${className}`}
            disabled={disabled}
            style={style}
        >
            <span>{children}</span>
            {showArrow && (
                <svg className="login-arrow" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M13 7l5 5m0 0l-5 5m5-5H6" strokeWidth="2" stroke="currentColor" fill="none" />
                </svg>
            )}
        </button>
    );
};

export default PrimaryButton;
